import styled from 'styled-components';
import { typography, theme } from 'dab-component-lib';
import { MediaStyle, basic } from '../../../utils/style-utils';

export const SecNavStyle = styled.nav`
  background-color: ${basic.greyGreen};
  ${ MediaStyle.smOnly`
    position: fixed;
    z-index: ${theme.zIndex.overthetop};
    top: 0;
    left: 0;
    height: 96vh;
    width: 90vw;
    background: white;
    transition: transform ease 250ms;
    transform: translateX(-90vw);
    & > div > div > div {
      flex-grow: 1;
    }
    ${props => props.openMenu && `
      transform: translateX(0);
    `}
  ` }
`;

export const CatalogueLink = styled.div`
  display: none;
  align-items: center;
  color: ${basic.secondary};
  cursor: pointer;
  padding: 15px 5px;
  ${typography.Body1}
  span {
    margin-left: 8px;
  }
  ${ MediaStyle.md`
    display: flex;
  ` }
  ${ MediaStyle.lg`
    ${typography.Subheader1}
  ` }
`;

export const Labels = styled.ul`
  list-style: none;
  margin: 0;
  padding: 0;
  li {
    border-bottom: 1px solid #eaeaea;
    &:first-child {
      border-top: 1px solid #eaeaea;
    }
  }
  ${ MediaStyle.md`
  align-items: center;
  justify-content: flex-end;
  display: flex;
  flex-wrap: wrap;
  li, li:first-child {
    border: none;
  }
  `}
`;

export const Label = styled.a`
  ${typography.Body2}
  color: ${basic.secondary};
  display: block;
  cursor: pointer;
  padding: 8px 15px;
  ${ MediaStyle.md`
    text-transform: uppercase;
    padding: 15px;
    ${typography.Caption1}
  ` }
  ${ MediaStyle.lg`
    ${typography.Body2}
  ` }
`;

export const MobileTitleStyle = styled.h2`
  ${typography.Subheader1}
  color: ${basic.secondary};
  padding: 0 5px;
  ${ MediaStyle.md`
    display: none;
  ` }
`;


// WEBPACK FOOTER //
// ./src/components/common/secNav/style.js